import React, { Component } from 'react'
import StarIcon from 'icons/StarIcon'
import StarOutlineIcon from 'icons/StarOutlineIcon'
import styles from './StarMeter.css'

const Star = ({ on, rating, onChoose }) => {
  let Star = on ? StarIcon : StarOutlineIcon
  let clss = on ? styles.on : styles.off
  return <Star className={clss} onClick={onChoose} />
}

class StarMeter extends Component {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.state = {}
  }
  componentWillReceiveProps(newProps) {
    let { newRating } = this.state
    let { rating } = newProps
    if (newRating && rating === newRating) {
      this.setState({})
    }
  }
  onChange(newRating) {
    let { onChange, rating, readonly = false } = this.props
    if (!readonly) {
      if (newRating !== rating) {
        this.setState({
          newRating
        })
        if (onChange) onChange(newRating)
      }
    }
  }
  render() {
    let { stars = 5, rating = 0, onChange, readonly } = this.props
    let { newRating } = this.state
    let _rating = newRating !== undefined ? newRating : rating
    let _stars = []
    for (let i = 1; i <= stars; i++) {
      _stars.push(
        <Star
          key={'r' + i}
          on={_rating >= i}
          rating={i}
          onChoose={
            readonly
              ? null
              : () => {
                  this.onChange(i)
                }
          }
        />
      )
    }
    return (
      <div
        className={[
          styles.star_meter,
          readonly ? styles.inactive : styles.active,
          newRating !== undefined ? styles.choosing : ''
        ].join(' ')}
      >
        {_stars}
      </div>
    )
  }
}

export default StarMeter
